const CVData = [
  {
    id: 0,
    title: 'Frontend Development',
    experience: [
      {
        degree: 'Higher Professional Degree in Frontend Development',
        school: 'Noroff - School of Technology and Digital Media',
        years: [2019, 2021],
      },
      '2 years of coding experience',
      '1 freelance project',
    ],
    description: ` I began studying front-end development at Noroff Vocational School in Bergen in 2019, where I've gained knowledge and experience with HTML, CSS and JavaScript/TypeScript, as well JavaScript frameworks such as React and Next.js. 

    My time studying web development has been exciting, in that it has opened up another medium for creativity.`,
    skill_name: 'Languages:',
    skills: [
      'HTML',
      'CSS/SASS',
      'JavaScript',
      'Typescript',
      'React',
      'Next.js',
    ],
    tools: [
      'Atom',
      'VSCode',
      'Bootstrap',
      'Github',
      'Strapi',
      'Wordpress',
      'Heroku',
    ],
  },
  {
    id: 1,
    title: 'Visual Design',
    experience: [
      {
        degree: 'Higher Professional Degree in Frontend Development',
        school: 'Noroff - School of Technology and Digital Media',
        years: [2019, 2021],
      },
      '3 years of graphic design and freelance experience ',
    ],
    description: `Before studying frontend development, I've had a bit of experience in terms of design, where I have worked freelance by designing logos for other artists and music producers. `,
    skill_name: 'I design:',
    skills: ['UX', 'UI', 'Logos', 'Brand Material'],
    tools: [
      'Adobe Photoshop',
      'Adobe Illustrator',
      'Adobe XD',
      'Figma',
      'Pen & Paper',
      'Adobe Premiere',
    ],
  },
  {
    id: 2,
    title: 'Concept Art & Illustration',
    experience: [
      {
        degree: 'Cinematic Design - Evenant Course',
        school: 'Cinematic Design - Evenant Course',
        years: [2018],
      },
      '6 years of freelance experience ',
    ],
    description: ` As far as I can remember, I've always been interested in fantasy fiction. Whether it was a book, a movie, a game or a TV show, the attraction I felt towards fantastical worlds outside our own was present in all of them. From this I've been drawing and recreating scenarios like them. Which has led me into the world of concept art and design.

    Nowadays I draw freelance, making album covers for artists and other brand material, or helping someone get their ideas onto a canvas. It is a field that is very fulfilling and also very fun.  `,
    skill_name: 'I draw:',
    skills: ['Environments', 'Characters', 'Album Covers', 'Brand Material'],
    tools: [
      'Adobe Photoshop',
      'Adobe Illustrator',
      'Adobe XD',
      'Figma',
      'Pen & Paper',
      'Adobe Premiere',
    ],
  },
  {
    id: 3,
    title: 'Sound & Music Production',
    experience: [
      {
        degree: 'Higher Professional Degree in sound & Music Production',
        school: 'Noroff - School of Technology and Digital Media',
        years: [2017, 2019],
      },
      'Been producing music since 2012',
    ],
    description: ` "Amaryllis has been producing drum & bass since 2012, with her first EP, ‘Never Again’, released on Surreal Recordings; now, her latest EP ‘Light Pillars’ marks her Subsphere Records debut. Drawing influence from Netsky, Fred V & Grafix, Camo & Krooked, Culture Shock, Logistics, and more, Amaryllis’ bright and energetic sound is a welcome addition to the Subsphere family.

    Creating everything from dubstep to orchestral music, her vast array of influence and talent is made evident in her four track EP, delivering the producers intended escapism through an incredibly immersive, bright atmosphere." - jungledrumandbass.co.uk `,
    skill_name: 'I make:',
    skills: [
      'Sound Design',
      'Electronic Music',
      'Drum & Bass',
      'Dubstep',
      'Ambient',
    ],
    tools: [
      'Ableton Live 10 Suite',
      'NI Kontakt',
      'LennarDigital Sylenth1',
      'Xfer Serum',
      'Bass Guitar',
      'Akai MKP mini',
    ],
  },
];

export default CVData;
